import React from "react";

export const Login = React.lazy(() => import("./Login/index.page"));
export const ForgotPassword = React.lazy(() =>
  import("./ForgotPassword/index.page")
);
export const DeleteAccount = React.lazy(() =>
  import("./DeleteAccount/index.page")
);
export const DeleteAccountRequest = React.lazy(() =>
  import("./DeleteAccountRequest/index.page")
);
export const ResetPassword = React.lazy(() =>
  import("./ResetPassword/index.page")
);
export const Signup = React.lazy(() => import("./Signup/index.page"));
export const UserHome = React.lazy(() => import("./Home/index.page"));
export const CreateMemorials = React.lazy(() =>
  import("./CreateMemorials/index.page")
);
export const BiographiesPage = React.lazy(() =>
  import("./BiographiesPage/index.page")
);
export const UserDashboard = React.lazy(() =>
  import("./UserDashboard/index.page")
);
export const Theme02 = React.lazy(() => import("./Theme02/index.page"));
export const Theme01 = React.lazy(() => import("./Theme01/index.page"));
export const Theme04 = React.lazy(() => import("./Theme04/index.page"));
export const Theme03 = React.lazy(() => import("./Theme03/index.page"));
export const EditProfile = React.lazy(() => import("./EditProfile/index.page"));
export const SearchBiography = React.lazy(() =>
  import("./SearchBiography/index.page")
);
export const SavedBiography = React.lazy(() =>
  import("./SavedBiography/index.page")
);
export const SearchByLocation = React.lazy(() =>
  import("./SearchByLocation/index.page")
);

export const ShareBiography = React.lazy(() =>
  import("./ShareBiography/index.page")
);
export const MyBiographies = React.lazy(() =>
  import("./MyBiographies/index.page")
);
export const CmsPage = React.lazy(() => import("./Cms/index.page"));
export const Profile = React.lazy(() => import("./Profile/index.page"));
export const Notification = React.lazy(() =>
  import("./Notification/index.page")
);
export const Faq = React.lazy(() => import("./Faq/index.page"));
export const ChoosePlan = React.lazy(() => import("./ChoosePlan/index.page"));
export const LayoutThree = React.lazy(() => import("./LayoutThree/index.page"));
export const LayoutFour = React.lazy(() => import("./LayoutFour/index.page"));
export const Payment = React.lazy(() => import("./Payment/index.page"));
export const UserProfile = React.lazy(() => import("./UserProfile/index"));
export const ChangePassword = React.lazy(() =>
  import("./ChangePassword/index.page")
);
export const Subscription = React.lazy(() =>
  import("./Subscription/index.page")
);
export const Transaction = React.lazy(() => import("./Transaction/index.page"));
export const SavedCard = React.lazy(() => import("./SavedCard/index.page"));

export const Support = React.lazy(() => import("./Support/index.page"));
export const ContactUs = React.lazy(() => import("./ContactUs/index.page"));
export const OtpVerification = React.lazy(() =>
  import("./OtpVerification/index.page")
);
export const PendingComments = React.lazy(() =>
  import("./PendingComments/index.page")
);

export const FamilyTree = React.lazy(() => import("./FamilyTree/index.page"));

export const ScreenShot = React.lazy(() => import("./ScreenShot/index.page"));
export const AdvanceSearch = React.lazy(() =>
  import("./AdvanceSearch/index.page")
);
export const HeaderSearch = React.lazy(() =>
  import("./HeaderSearch/index.page")
);
export const ReportCategoryForm = React.lazy(() =>
  import("./ReportCategory/index.page")
);
export { default as CouponCode } from "./CouponCode";
